import { HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { AppInitializeService } from './common/services/appInitialize.service';
import { ROUTES } from './app.routes';
import { SharedModule } from './common/utilities/shared/shared.module';
import { CookieService } from 'ngx-cookie-service';
import { Ng2CompleterModule } from 'ng2-completer';
import { VehicleRegistrationComponent } from './vehicleRegistration/vehicleRegistration.component';
import { AppRejectComponent } from './applicationReject/appReject.component';
import { NonStpComponent } from './nonStp/nonStp.component';
import { OfferAddComponent } from './offerAdd/offerAdd.component';
import { MultitabFailedComponent } from './multitabFailed/multitabFailed.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { BackButtonDisableModule } from 'angular-disable-browser-back-button';
import { QuicklinkModule, QuicklinkStrategy } from 'ngx-quicklink';
import { StorageService } from './common/services/local-storage.service';
import { SeoBikeBfdlComponent } from './vehicleRegistration/seo/seo-bike-bfdl/seo-bike-bfdl.component';
import { SeoBikeBflComponent } from './vehicleRegistration/seo/seo-bike-bfl/seo-bike-bfl.component';
import { SeoCarBfdlComponent } from './vehicleRegistration/seo/seo-car-bfdl/seo-car-bfdl.component';
import { SeoCarBflComponent } from './vehicleRegistration/seo/seo-car-bfl/seo-car-bfl.component';
import { GeneralInsuranceComponent } from './app-home/general-insurance/general-insurance.component';
import { environment } from 'src/environments/environment';
import { provideSecurity } from 'src/lib/security';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    VehicleRegistrationComponent,
    AppRejectComponent,
    NonStpComponent,
    OfferAddComponent,
    MultitabFailedComponent,
    SeoBikeBfdlComponent,
    SeoBikeBflComponent,
    SeoCarBfdlComponent,
    SeoCarBflComponent,
    GeneralInsuranceComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    Ng2CompleterModule,
    FormsModule,
    QuicklinkModule,
    RouterModule.forRoot(ROUTES, { useHash: false, preloadingStrategy: QuicklinkStrategy, scrollPositionRestoration: "enabled", }),
    SharedModule,
    NgMultiSelectDropDownModule.forRoot(),
    BackButtonDisableModule.forRoot()
  ],
  exports: [RouterModule],
  providers: [
    AppInitializeService,
    // Security Library Integration - Static Configuration in app.modules.ts
    provideSecurity({
      enableEncryption: true,
      publicKeyEndpoint: environment.serviceBaseUrls.DOMAIN01 + '/v1/crypto/init',
      expectedPublicKeyHash: '8b935bb3f35da8069d860a7f9c06d7b6514b00a9b7d437ed55f7c7f4ebbc5f30',
      encryptDecryptForEndpoints: ['*'], 
      skipEncryptDecryptForEndpoints: [
        // 'stage-aem-api.bajajfinserv.in',
        // 'aem-api.bajajfinserv.in',
        '.json'
      ],
      enableDebugLogging: false,
      publicKeyFetchRetries: 3
    }),
    CookieService,
    StorageService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
  entryComponents: [AppComponent]
})
export class AppModule { }
